<div class="p-editor-content ql-container ql-snow">
  <div class="ql-editor" [innerHTML]="articleHtml"></div>
</div>
